import { createAction } from 'redux-actions';
import api from '../../services/api';
import {
  SAVE_PAGE,
  SAVE_PAGE_SUCCESS,
  SAVE_PAGE_FAILURE,
  ADD_PAGE_TO_THE_LIST,
  UPDATE_PAGE_IN_THE_LIST
} from './actionTypes';
import { change } from 'redux-form';

//<<<---SAVE-PAGE--->>>
export const savePageInProgress = createAction(SAVE_PAGE);
export const savePageSuccess = createAction(SAVE_PAGE_SUCCESS);
export const addPageToTheList = createAction(ADD_PAGE_TO_THE_LIST);
export const savePageFailure = createAction(SAVE_PAGE_FAILURE);

export const savePage = (formData, lang, callback) => async dispatch => {
  dispatch(savePageInProgress());
  try {
    const res = await api.post(`page/${lang}`, formData);
    const { data } = res;
    callback();
    dispatch(savePageSuccess(data));
    dispatch(addPageToTheList(data));
  } catch (error) {
    dispatch(savePageFailure(error));
  }
};

//<<<---UPDATE-PAGE--->>>
export const updatePageInTheList = createAction(UPDATE_PAGE_IN_THE_LIST);

export const updatePage = (formData, id, lang, callback) => async dispatch => {
  dispatch(savePageInProgress());
  try {
    const res = await api.post(`page/${id}/${lang}`, formData, {
      headers: { 'X-HTTP-Method-Override': 'PUT' }
    });
    const { data } = res;
    callback();
    dispatch(savePageSuccess(data));
    dispatch(updatePageInTheList(data));
  } catch (error) {
    dispatch(savePageFailure(error));
  }
};

export const setValueToEmptyObject = (formName, fieldName) => () =>
  change(formName, fieldName, {});



// WEBPACK FOOTER //
// ./src/modules/PageForm/actions.js